// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings[data-v-369077d4]{min-height:348px}.settings__content[data-v-369077d4]{position:relative}@media(max-width:1279px){.settings__content[data-v-369077d4] .changes-saved{position:absolute;top:-30px;right:24px}}", ""]);
// Exports
module.exports = exports;
